import AppConstants from 'constants/AppConstants';

interface UIState {
  mobileModeEnabled: boolean;
  selectedGuestListTab: 'guestList' | 'notifyList' | 'orderList';
}

const initialState: UIState = {
  mobileModeEnabled: true,
  selectedGuestListTab: 'guestList',
};

export default function reducer(state = initialState, action: BaseTockAction): UIState {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.PERSISTED_UI_TOGGLE_MOBILE_MODE: {
      return {
        ...state,
        mobileModeEnabled: !state.mobileModeEnabled,
      };
    }

    case 'SELECT_GUEST_LIST_TAB': {
      return {
        ...state,
        selectedGuestListTab: payload,
      };
    }

    default:
      return state;
  }
}
